module.exports = __webpack_public_path__ + "static/media/heartnew.c18be963.svg";